import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../shared/buttons/Button';
import ContainerHeader from '../shared/container/ContainerHeader';
import Search from '../shared/search/Search';
import { createNoteAction, setUserNotesSearchAction } from '../../redux/actions/notesActions';

const NotesHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = useSelector((state) => state.notes?.userNotesSearch);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setUserNotesSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleCreateNote = async () => {
    setLoading(true);
    const created = await dispatch(
      createNoteAction({
        title: 'Нова нотатка',
        content: '',
        plainText: '',
        isPublic: false,
      }),
    );
    setLoading(false);
    if (created?.id) {
      navigate(`/notes/${created.id}`);
    }
  };

  return (
    <ContainerHeader>
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={handleCreateNote}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default NotesHeader;
